import { PaginationState } from "@tanstack/react-table"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import type { FindEcoModulationProductsResponseDto } from "~/gen/api"
import { useEcoModulationColumns } from "~/pages/Brand/Regulations/EcoModulations/columns"

type Props = {
  pagination: PaginationState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
  pageCount: number
  products: FindEcoModulationProductsResponseDto[]
}

export const useEcoModulationTable = ({
  pagination,
  setPagination,
  pageCount,
  products,
}: Props) => {
  const columns = useEcoModulationColumns()

  return useCustomReactTable({
    data: products,
    columns,
    initialColumnPinning: {
      left: ["name", "reference"],
    },
    state: {
      pagination,
    },
    getRowId: (row) => row.id,
    pageCount,
    manualPagination: true,
    onPaginationChange: setPagination,
  })
}
